import React, { Component } from 'react';
import { connect } from 'react-redux'
import moment from 'moment';

import Loader from '../../../../common/components/notifications/Loader';
import TranscriptManager from './transcript/TranscriptManager';
import { getHasRequestPending } from '../../../../redux/data/selectors';

function getPublishedAsset (assets) {
    if (!assets) {
        return false;
    }
    for (var i = 0; i < assets.length; i++) {
        if (assets[i].type == "video" && assets[i].currentStatus == "archive") {
            return assets[i];
        }
    }
    return false;
}

// @XXX This is messy and should be refactored.
function calculateCost (transcript, event) {
    let cost = 0;
    let err = false;
    let title, statusText;

    if (transcript.data) {
        /*
            Transcript has been (or is being) created
        */
        try {
            const { billableMinutes, status } = transcript.data;
            switch (status) {
                case 'finished':
                case 'accepted':
                case 're-syncing':
                    cost = parseFloat(billableMinutes);
                    title = 'Billable Minutes Processed';
                    statusText = status;
                    break;
            }
        } catch (e) {
            console.log('err', e);
            err = true;
        }

    } else if (!event.transcripts) {
        /*
            No transcript has been processed (or one was deleted) for this event
        */
        const publishedAsset = getPublishedAsset(event.mediaAssets);

        if (publishedAsset) {
            const runTime = moment(publishedAsset.totalRunTime, 'HH:mm:ss');

            if (runTime.isValid()) {
                try {
                    title = 'Estimated Cost to Transcribe';
                    var minutes = Math.floor(publishedAsset.totalRunTimeS / 60);
                    cost = Number(minutes * .05).toFixed(2);
                    cost = <span><small>$</small> {cost} </span>
                } catch (e) {
                    cost = 0;
                    err = true;
                    title = false;
                }
            }

        } else {
            return (<div className="alert alert-info cost-alert">
                <h4>No Transcript</h4>

                <div className="cost-price">
                    {null}
                </div>

                <div className="cost-status">
                    <small>Status: <strong>Event Not Published</strong></small>
                </div>
            </div>);
        }
    }

    var cssClass = (
        (statusText === 're-syncing') || (statusText === 'accepted')
    ) ? 'alert-warning' : 'alert-info';

    return (<div className={'alert ' + cssClass + ' cost-alert'}>
        <div className="cost-price">
            <span>
                {(!err) ? cost : null}
            </span>
        </div>

        <h4>{(err) ? "Error Processing Transcript" : title}</h4>

        {(!err ? <hr/> : null)}

        <div className="cost-status">
            {(!err && statusText) ?
                <small>Status: <strong>{statusText}</strong></small> :
                null}
        </div>
    </div>);
}

class EventTranscription extends Component {
    constructor (props) {
        super(props);
    }

    componentWillMount () {
        this.props.actions.transcript.getTranscriptInfo({
            eventID: this.props.event.eventID
        });
    }

    render () {
        if (this.props.transcript.resolving) {
            return <Loader message="Fetching"/>;
        }

        const event = this.props.event
        const { transcript } = this.props;

        return (<div className="col-xs-12">
            <div className="col-sm-9">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3>Event Transcription</h3>
                        <p>
                            Transcription is billed per-minute, and will be add to your monthly bill.
                        </p>
                    </div>

                    <div className="panel-body">
                        <TranscriptManager
                            {...this.props.transcriptView}
                            requests={this.props.requests.transcript}
                            actions={this.props.actions}
                            event={event}
                            transcript={transcript}
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-3">
                {calculateCost(transcript, event)}
            </div>
        </div>);
    }
}

EventTranscription.propTypes = {};

const mapStateToProps = (state, ownProps) => {
    const eventID = ownProps.event.eventID
    const transcript = { data: state.data.eventTranscripts[eventID], resolving: getHasRequestPending(state, ['BUS/http.transcript.getTranscriptInfo'])}
    return { transcript }
}

export default connect(mapStateToProps)(EventTranscription)
